import {
  ValidateIf,
  IsString,
  IsNotEmpty,
  IsBoolean,
  IsIn,
  IsUUID,
  IsArray,
  IsOptional,
} from 'class-validator';

import {
  WorkflowNodeActionAttribute,
  WorkflowNodeActionAttributeChoice,
} from '@app/gen/settings';

export class NodeActionAttributeDto {
  @IsUUID()
  @IsNotEmpty({ message: 'Обязательное поле' })
  id: string;

  @IsString()
  @IsNotEmpty({ message: 'Обязательное поле' })
  name: string;

  @IsString()
  @IsOptional()
  description?: string;

  @IsIn([
    'text',
    'textarea',
    'date',
    'datetime',
    'file',
    'file_multiple',
    'choice',
    'year',
    'text_catalog',
    'url',
    'employee',
  ])
  @IsNotEmpty({ message: 'Обязательное поле' })
  type: WorkflowNodeActionAttribute['type'];

  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  required: boolean;

  @ValidateIf(
    (dto: NodeActionAttributeDto) =>
      dto.type === 'choice' ||
      dto.type === 'text_catalog' ||
      dto.type === 'year',
  )
  @IsBoolean()
  @IsNotEmpty({ message: 'Обязательное поле' })
  isMultiple: boolean;

  @IsArray()
  @IsOptional()
  choices?: WorkflowNodeActionAttributeChoice[];

  @IsString()
  @IsOptional()
  catalogName?: string;
}
